import { Sunrise, Headphones, NotebookPen, Moon } from "lucide-react";
import { Reveal } from "@/components/site/Motion";

const DAY = [
  { icon: Sunrise, t: "A short theme for the day", d: "An introduction to the layer you're exploring and one question to carry with you." },
  { icon: Headphones, t: "A guided practice", d: "A brief practice for the senses, the breath or stillness, depending on the stage." },
  { icon: NotebookPen, t: "A moment of reflection", d: "A simple prompt to notice what came up, written down or simply considered." },
  { icon: Moon, t: "Gentle release", d: "A small, conscious action to close the day and let something go." },
];

export const DayPanel = () => (
  <Reveal className="relative overflow-hidden rounded-[2rem] bg-[#221e1b] p-7 text-[#faf5ee] sm:p-10" >
    <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-[radial-gradient(circle,rgba(212,166,74,0.35),transparent_65%)]" />
    <div className="relative flex flex-wrap items-center justify-between gap-4">
      <h3 className="font-display w-full text-center text-[2.5rem] font-medium leading-tight sm:text-left sm:text-[2.75rem]" data-testid="day-panel-title">A day on the journey</h3>
    </div>
    <ol className="relative mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
      {DAY.map(({ icon: Icon, t, d }, i) => (
        <li key={t} className="flex flex-col gap-4" data-testid={`day-item-${i + 1}`}>
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#faf5ee]/20">
            <Icon className="h-5 w-5 text-[#e8c77e]" strokeWidth={1.5} />
          </span>
          <div>
            <p className="text-[1.0625rem] font-semibold leading-snug">{t}</p>
            <p className="mt-2 text-base leading-[1.7] text-[#d9cfc2]">{d}</p>
          </div>
        </li>
      ))}
    </ol>
  </Reveal>
);

const DETAILS = [
  { k: "Availability", v: "Coming soon. Inquire for the next cohort; private 1:1 coaching is available now" },
  { k: "Duration", v: "21 days" },
  { k: "Daily time", v: "1 hour per day" },
  { k: "Shape", v: "Five stages of four days each, plus a closing day to bring it all together" },
  { k: "Experience", v: "None needed. Every layer is introduced from the beginning" },
];

export const PracticalDetails = () => (
  <Reveal className="rounded-[2rem] border border-[#e4dacb] bg-[#fffaf3] p-7 sm:p-10" >
    <div className="flex flex-wrap items-center justify-between gap-4">
      <h3 className="font-display w-full text-center text-[2.5rem] font-medium leading-tight text-[#221e1b] sm:text-left sm:text-[2.75rem]">Practical details</h3>
    </div>
    <dl className="mt-8 divide-y divide-[#e4dacb]" data-testid="practical-details">
      {DETAILS.map((d) => (
        <div key={d.k} className="grid gap-2 py-5 sm:grid-cols-[112px_minmax(0,1fr)] sm:gap-6">
          <dt className="text-[0.8125rem] font-semibold uppercase tracking-[0.12em] text-[#5d544c] sm:pt-1">{d.k}</dt>
          <dd className="text-[1.0625rem] leading-[1.7] text-[#221e1b]">{d.v}</dd>
        </div>
      ))}
    </dl>
  </Reveal>
);
